import { useParams, Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import ProjectSection from '_/common/components/layout/ProjectSection';
import { useProject } from '_/contexts/ProjectContext';
import useDocumentTitle from '_/hooks/useDocumentTitle';
import React, { ReactElement } from 'react';

function SelectedProjectContent(): ReactElement {
  const params = useParams({ strict: false }) as Partial<{ projectSlug: string }>;
  const projectSlug = params.projectSlug || '';
  const { selectedProject: project, isLoading } = useProject();

  useDocumentTitle(`${project?.name || 'Project'} :: ${location.pathname.split('/').pop()}`);

  // Don't render anything for special route slugs - they're handled by other components
  if (projectSlug === '_new') {
    return <></>;
  }

  const isProjectLoading = !project || isLoading;

  return (
    <AsyncPageContainer isLoading={isProjectLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedProject(): ReactElement {
  return (
    <ProjectSection>
      <SelectedProjectContent />
    </ProjectSection>
  );
}

export default SelectedProject;
